import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

// svc-04 `/v1/tooling-sets*`. Composite PK `(toolingSetId, machineType)` —
// exposed via `?toolingSetId=&machineType=` query params on the `/lookup`
// sub-path. Bare collection path is the paginated list / create.

export interface ToolingSet {
  toolingSetId: string;
  machineType: string;
  lowerTool: string | null;
  upperTool: string | null;
  shuttle: string | null;
  multiModule: string | null;
  flightTube: string | null;
  toolingType: string | null;
  orientation: string | null;
  singulation: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PaginatedToolingSets {
  data: ToolingSet[];
  pagination: PaginationMeta;
}

export interface ListToolingSetsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface ToolingSetKey {
  toolingSetId: string;
  machineType: string;
}

export interface ToolingSetWriteBody {
  toolingSetId: string;
  machineType: string;
  lowerTool?: string | null;
  upperTool?: string | null;
  shuttle?: string | null;
  multiModule?: string | null;
  flightTube?: string | null;
  toolingType?: string | null;
  orientation?: string | null;
  singulation?: string | null;
}

export async function listToolingSets(
  params: ListToolingSetsParams = {},
): Promise<PaginatedToolingSets> {
  const res = await Api.get("/v1/tooling-sets", { params });
  return unwrap<PaginatedToolingSets>(res.data);
}

export async function getToolingSet(key: ToolingSetKey): Promise<ToolingSet> {
  const res = await Api.get("/v1/tooling-sets/lookup", { params: key });
  return unwrap<ToolingSet>(res.data);
}

export async function createToolingSet(body: ToolingSetWriteBody): Promise<ToolingSet> {
  const res = await Api.post("/v1/tooling-sets", body);
  return unwrap<ToolingSet>(res.data);
}

export async function updateToolingSet(
  oldKey: ToolingSetKey,
  body: ToolingSetWriteBody,
): Promise<ToolingSet> {
  const res = await Api.put("/v1/tooling-sets/lookup", body, { params: oldKey });
  return unwrap<ToolingSet>(res.data);
}

export async function deleteToolingSet(key: ToolingSetKey): Promise<void> {
  await Api.delete("/v1/tooling-sets/lookup", { params: key });
}
